<div id="my_dataviz"></div>
<div id="my_dataviz1" class="legend">
    <div class="flex-container">
        <div style="background-color:rgb(165, 0, 38);"><span style="color:white">-1</span></div>
        <div style="background-color:rgb(219, 61, 47);"></div>
        <div style="background-color:rgb(247, 135, 79);"></div>
        <div style="background-color:rgb(253, 200, 120);"></div>
        <div style="background-color:rgb(254, 238, 163);"></div>
        <div style="background-color:rgb(244, 248, 172);">0</div>
        <div style="background-color:rgb(210, 236, 138);"></div>
        <div style="background-color:rgb(140, 205, 104);"></div>
        <div style="background-color:rgb(100, 188, 97);"></div>
        <div style="background-color:rgb(25, 141, 74);"></div>
        <div style="background-color:rgb(0, 104, 55);"><span style="color:white">1</span></div>
    </div>
    <span class="legendColor">
        {{'common.Legend' | translate}}
    </span>
</div>